// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dropdown-container[data-v-62fc6764]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;gap:16px}.dropdown-item[data-v-62fc6764]{-webkit-box-flex:1;-ms-flex:1 1 50%;flex:1 1 50%;max-width:50%;min-width:0}", ""]);
// Exports
module.exports = exports;
